import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterList, beforeList } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function BeforeAfter() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-16" data-mp="3ogj8jjd1u8h1">
      <SectionHeading eyebrow="AVANT VS. APRÈS" title={<>Arrêtez de tout préparer <span className="text-gold" data-id="element-18" data-mp="3eq83tuljjv93">de zéro.</span></>} data-id="element-17" data-mp="3sh378rd9tk5a" />
      <div className="mx-auto mt-10 grid max-w-5xl gap-4 md:grid-cols-2" data-id="element-19" data-mp="3eon7q0jkw494">
        <div className="rounded-2xl border border-line bg-ink p-5 sm:p-6" data-id="element-20" data-mp="3jhq1o9s9pfpu">
          <h3 className="text-sm font-bold tracking-widest text-mute" data-id="element-21" data-mp="34saef3ry3sew">SANS LE MAÎTRE DE LA GUITARE</h3>
          <ul className="mt-5 space-y-4" data-id="element-22" data-mp="39q3ldz12oqg8">
            {beforeList.map(b => <li key={b} className="flex gap-3 text-mute" data-id="element-23" data-mp="2vrcasmlf5mwu">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-ribbon" aria-hidden data-id="element-24" data-mp="2vrvrjzzc259a" />
                {b}
              </li>)}
          </ul>
        </div>
        <div className="rounded-2xl border-2 border-gold bg-ink p-5 sm:p-6" data-id="element-25" data-mp="x3ir4rfbn3mz">
          <h3 className="text-sm font-bold tracking-widest text-gold" data-id="element-26" data-mp="t38it842414y">AVEC LE MAÎTRE DE LA GUITARE</h3>
          <ul className="mt-5 space-y-4" data-id="element-27" data-mp="1739n6xjj5qp6">
            {afterList.map(a => <li key={a} className="flex gap-3 text-cream" data-id="element-28" data-mp="123n8ejo202e9">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-29" data-mp="1246jbgfadqis" />
                {a}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}